var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button",class:_vm.divise,style:({height: _vm.size2})},[_c('div',{staticClass:"switch-button-content"},[(_vm.icon)?_c('icon',{attrs:{"file":_vm.icon,"size":_vm.size}}):_vm._e(),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }